module.exports = __webpack_public_path__ + "img/Gallery_1_07.a9755271.jpeg";